import { render, staticRenderFns } from "./MaintenanceOverview.vue?vue&type=template&id=153457ce&"
import script from "./MaintenanceOverview.vue?vue&type=script&lang=js&"
export * from "./MaintenanceOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports